export function getdata() {
	let obj = {
		
			headData: [{
					title: "项目",
					prop:'title',
					width: "300px",
					custom: true,
				},
				{
					title: "行次",
					prop: "grade",
					custom: true,
					width: "100px"
				},
				{
					title:'本年累计金额',
					prop:'cwbbxqykjzz_1_x_1',
					width: "200px",
					custom: true,
				},
				{
					title:'本月金额',
					prop:'cwbbxqykjzz_1_x_2',
					width: "200px",
					custom: true,
				},
			],
			tableData: [{
					title: "一、经营活动产生的现金流量：",
					grade: "",
					disabledcwbbxqykjzz_1_x_1:true,
					disabledcwbbxqykjzz_1_x_2:true,
					cwbbxqykjzz_1_x_1: {},
					cwbbxqykjzz_1_x_2: {},
				},
				{
					title: "销售产成品、商品、提供劳务收到的现金",
					grade: "1",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_1_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "收到其他与经营活动有关的现金",
					grade: "2",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_2_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "购买原材料、商品、接受劳务支付的现金",
					grade: "3",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_3_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "支付的职工薪酬",
					grade: "4",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_4_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "支付的税费",
					grade: "5",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_5_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "支付其他与经营活动有关的现金",
					grade: "6",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_6_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "经营活动产生的现金流量净额",
					grade: "7",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_7_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "二、投资活动产生的现金流量：",
					grade: "",
					disabledcwbbxqykjzz_1_x_1:true,
					disabledcwbbxqykjzz_1_x_2:true,
					cwbbxqykjzz_1_x_1: {},
					cwbbxqykjzz_1_x_2: {},
				},{
					title: "收回短期投资、长期债券投资和长期股权投资收到的现金",
					grade: "8",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_8_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "取得投资收益收到的现金",
					grade: "9",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_9_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "处置固定资产、无形资产和其他非流动资产收回的现金净额",
					grade: "10",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_10_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "短期投资、长期债券投资和长期股权投资支付的现金",
					grade: "11",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_11_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "购建固定资产、无形资产和其他非流动资产支付的现金",
					grade: "12",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_12_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "投资活动产生的现金流量净额",
					grade: "13",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_13_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "三、筹资活动产生的现金流量：",
					grade: "",
					disabledcwbbxqykjzz_1_x_1:true,
					disabledcwbbxqykjzz_1_x_2:true,
					cwbbxqykjzz_1_x_1: {},
					cwbbxqykjzz_1_x_2: {},
				},{
					title: "取得借款收到的现金",
					grade: "14",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_14_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "吸收投资者投资收到的现金",
					grade: "15",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_15_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "偿还借款本金支付的现金",
					grade: "16",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_16_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "偿还借款利息支付的现金",
					grade: "17",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_17_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "分配利润支付的现金",
					grade: "18",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_18_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "筹资活动产生的现金流量净额",
					grade: "19",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_19_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "四、现金净增加额",
					grade: "20",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_20_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "加：期初现金余额	",
					grade: "21",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_21_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				},{
					title: "五、期末现金余额",
					grade: "22",
					disabledcwbbxqykjzz_1_x_1:false,
					disabledcwbbxqykjzz_1_x_2:false,
					cwbbxqykjzz_1_x_1: {
						cellCode:"cwbbxqykjzz_1_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
					cwbbxqykjzz_1_x_2: {
						cellCode:"cwbbxqykjzz_1_22_1",
						cellType:"1",
						cellVal:"240040043.08"
					},
				}
			]
	}
	return obj
}
